import React from "react";
import { Workflow } from "../../../services/WorkflowService";
import { Application } from "../../../model_gen/application";
import { Button } from "../../ui/button";
import { Loader2Icon, SaveIcon, LayoutDashboardIcon } from "lucide-react";
import WorkflowApplicationSelect from "./WorkflowApplicationSelect";

interface WorkflowOverviewTabProps {
  workflow: Workflow;
  settingsApplicationId: number | undefined;
  setSettingsApplicationId: (val: number | undefined) => void;
  applications: Application[];
  savingApplication: boolean;
  onSaveApplication: () => void;
  onNewApplication: () => void;
}

const WorkflowOverviewTab: React.FC<WorkflowOverviewTabProps> = ({
  workflow,
  settingsApplicationId,
  setSettingsApplicationId,
  applications,
  savingApplication,
  onSaveApplication,
  onNewApplication,
}) => {
  const initialAppId = workflow.application_id ?? undefined;
  const applicationDirty = settingsApplicationId !== initialAppId;

  return (
    <div className="space-y-8">
      <div className="space-y-1">
        <div className="flex items-center gap-2 text-foreground">
          <LayoutDashboardIcon className="w-5 h-5 text-maitai-green" />
          <h2 className="text-lg font-gc-med">Overview</h2>
        </div>
        <p className="text-sm text-muted-foreground font-gc-reg max-w-2xl">
          The linked application controls where this workflow is grouped in the portal
          (for example, workflow runs on the application page). You can move the workflow
          to another application or clear the link.
        </p>
      </div>

      <div className="max-w-xl space-y-4 rounded-lg border border-border bg-muted/30 p-6">
        <WorkflowApplicationSelect
          value={settingsApplicationId}
          onChange={setSettingsApplicationId}
          applications={applications}
          onNewApplication={onNewApplication}
          labelId="wf-overview-application"
        />
        <div className="flex justify-end pt-2">
          <Button
            type="button"
            onClick={onSaveApplication}
            disabled={savingApplication || !applicationDirty}
            className="gap-2"
          >
            {savingApplication ? (
              <Loader2Icon className="w-4 h-4 animate-spin" />
            ) : (
              <SaveIcon className="w-4 h-4" />
            )}
            Save application
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkflowOverviewTab;
